/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 22/03/2024
 */

import auth from '../../../middleware/auth.js';
import shortcuts from '../../../middleware/shortcuts.js';
import {appHelper} from "../../../utils/helpers/appHelper.js";
import {routeHelper} from "../../../utils/helpers/routeHelper.js";

export const HrAppRegions = [
    {
        path: appHelper.path.hrApp + '/region',
        component: routeHelper.asyncComponentWithLoader(() => import('../../../views/layout/NavTab.vue')),
        meta: { middleware: [auth, shortcuts] },
        children: [
            {
                path: 'currency',
                name: 'hrAppCurrency',
                component: routeHelper.asyncComponentWithLoader(() => import('../../region/views/currency/index.vue'))
            },
            {
                path: 'country',
                name: 'hrAppCountry',
                component: routeHelper.asyncComponentWithLoader(() => import('../../region/views/country/index.vue'))
            },
            {
                path: 'state',
                name: 'hrAppState',
                component: routeHelper.asyncComponentWithLoader(() => import('../../region/views/state/index.vue'))
            },
            {
                path: 'city',
                name: 'hrAppCity',
                component: routeHelper.asyncComponentWithLoader(() => import('../../region/views/city/index.vue'))
            }
        ]
    }
];
